var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({staticClass:"s-img",attrs:{"src":_vm.src,"preview-src-list":_vm.previewList,"preview-teleported":true},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},'el-image',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }